<template>
  <div class="containerr">
    <div v-if="isDataReady">
      <div class="top-performer">
        Top performer : {{topPerformer.name}} <span class="top-performer__score">{{topPerformer.score}}</span>
      </div>
      <vue-chart :columns="chartColumns" :options="chartOptions" :rows="chartRows" chart-type="LineChart" :key="keyIdx"></vue-chart>
      <slot></slot>
    </div>
    <div class="column is-12 is-margin-top-40" v-else>
      <p class="has-text-centered">
        <img alt="Fetching chart data..." class="spinner" src="/static/img/loaders/spinner.svg"/>
      </p>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'ComparisonGraph',
    props: {
      dateRange: {
        type: Object,
        required: true
      },
      biz: {
        type: Array,
        required: true
      },
      apiEndpoint: {
        type: String,
        required: true
      },
      topPerformer: {
        type: Object,
        default () {
          return {
            name: '',
            score: '',
            setInApi: true
          }
        }
      }
    },
    data () {
      return {
        keyIdx: 0,
        isDataReady: false,
        chartColumns: [],
        chartRows: [],
        chartOptions: {
          pointSize: 14,
          legend: 'none',
          backgroundColor: '#fafafa',
          vAxis: {
            textStyle: {
              color: '#58595b',
              fontSize: 10
            }
          },
          hAxis: {
            textStyle: {
              color: '#58595b',
              fontSize: 10
            }
          },
          series: {
            0: {color: '#e2431e'},
            1: {color: '#e7711b'},
            2: {color: '#e7711b'},
            3: {color: '#e7711b'},
            4: {color: '#e7711b'}
          },
          height: 350,
          chartArea: {
            left: 30,
            right: 0,
            top: 25,
            bottom: 20
          },
          animation: {
            duration: 300,
            easing: 'out',
            startup: true
          }
        }
      }
    },
    created () {
      this.fetchChartData()
    },
    methods: {
      /**
       * Fetch the data for chart
       *
       * @returns {void}
       */
      fetchChartData () {
        this.isDataReady = false
        this.chartRows = []
        this.chartColumns = []
        this.keyIdx++

        if ('setInApi' in this.topPerformer) {
          this.topPerformer.name = ''
          this.topPerformer.score = ''
        }

        if (this.biz.length && this.dateRange.start_date) {
          const jsonBody = {
            dates: this.dateRange,
            businesses: this.biz
          }
          axios.post(`/competitors/${this.apiEndpoint}`, jsonBody)
            .then(({data}) => {
              this.chartColumns = data.columns
              this.chartRows = data.rows
              let counter = 0
              this.biz.forEach((business) => {
                this.chartOptions.series[counter].color = business.color
                counter++
              })
              if ('topScoreBiz' in data) {
                this.topPerformer.name = data.topScoreBiz
                this.topPerformer.score = data.topScore
              }

              this.isDataReady = true
            })
            .catch(() => {
              window.events.$emit('flash-error', {
                group: 'competitor-report',
                msg: 'There was an error retrieving the chart data, please try again later',
                gtmName: 'Failed fetching chart data on Competitors Index View'
              })
            })
        } else {
          this.isDataReady = true
        }
      }
    },
    watch: {
      dateRange () {
        this.fetchChartData()
      },
      biz () {
        this.fetchChartData()
      }
    }
  }
</script>

<style scoped>
  .containerr {
    padding: 27px 27px 15px 23px
  }

  .top-performer {
    font-size: 12px;
    color: #58595b;
  }

  .top-performer__score {
    font-size: 14px;
    font-weight: bold;
  }

  .spinner {
    width: 73px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/analytics/competitors/ComparisonGraph.vue